package com.eladfinish.bible.contest.features.review

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.russhwolf.settings.Settings
import kotlin.time.Duration.Companion.days

/** What the app remembers, across launches, about the user's way to a review request. */
class ReviewProgress(
    private val settings: Settings,
) {
    val successCount: Int
        get() = settings.getInt(SharedPrefsConstants.REVIEW_SUCCESS_COUNT, 0)

    val activeDays: Int
        get() = settings.getInt(SharedPrefsConstants.REVIEW_ACTIVE_DAYS_COUNT, 0)

    /** 0 while no request was ever made. */
    val lastRequestMillis: Long
        get() = settings.getLong(SharedPrefsConstants.REVIEW_LAST_REQUEST_MILLIS, 0L)

    /** Counts one more success, and one more active day when it is the first of its day. */
    fun recordSuccess(nowMillis: Long): Int {
        val newCount = successCount + 1
        settings.putInt(SharedPrefsConstants.REVIEW_SUCCESS_COUNT, newCount)

        val today = nowMillis / 1.days.inWholeMilliseconds
        if (settings.getLong(SharedPrefsConstants.REVIEW_LAST_SUCCESS_DAY, NO_DAY) != today) {
            settings.putLong(SharedPrefsConstants.REVIEW_LAST_SUCCESS_DAY, today)
            settings.putInt(SharedPrefsConstants.REVIEW_ACTIVE_DAYS_COUNT, activeDays + 1)
        }
        return newCount
    }

    fun markRequested(nowMillis: Long) {
        settings.putLong(SharedPrefsConstants.REVIEW_LAST_REQUEST_MILLIS, nowMillis)
    }

    private companion object {
        const val NO_DAY = -1L
    }
}
